var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlights3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 90,
    viewBox: "0 0 56 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 26.4286L46.7159 71.8143H9.13655L0 26.4286C0.133534 15.8857 7.73092 9.01429 14.0562 5.1C17.4553 3.0474 21.0541 1.35747 24.7952 0.0571429V33.6286C23.7341 34.317 22.9212 35.3365 22.4786 36.5342C22.0359 37.7319 21.9873 39.0432 22.3401 40.2713C22.6929 41.4995 23.4281 42.5782 24.4353 43.3457C25.4424 44.1132 26.6673 44.5281 27.9262 44.5281C29.1851 44.5281 30.41 44.1132 31.4172 43.3457C32.4243 42.5782 33.1595 41.4995 33.5123 40.2713C33.8651 39.0432 33.8165 37.7319 33.3739 36.5342C32.9312 35.3365 32.1183 34.317 31.0572 33.6286V0C34.8763 1.30231 38.5491 3.01183 42.0141 5.1C48.3956 9.01429 56 15.8857 56 26.4",
    fill: "#FC9194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9679 76.3572H4.85645V90H50.9679V76.3572Z",
    fill: "#FC9194"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlights3);
export default __webpack_public_path__ + "static/media/highlights-3.e21f8692ba33e82e2bda5a7529345636.svg";
export { ForwardRef as ReactComponent };